<template>
  <li
    class="option">
    <div class="option-header">
      <div class="option-meta">
        <span class="option-name">
          {{ option.name }}
          <ServiceInfo
            :link="option.link"
            :descr="option.descr"
          />
        </span>
        <div class="option-price">
          {{ optionPrice }}
        </div>
        <div v-if="option.connectPrice" class="option-price">
          {{ optionConnectPrice }}
        </div>
      </div>
      <el-tooltip :disabled="!option.autoAssigned" :content="$t('Подключается автоматически')">
        <el-switch
          :name="option.name"
          active-color="#f96333"
          inactive-color="#D5D5D5"
          class="option-toggle"
          :value="option.autoAssigned"
          :disabled="option.autoAssigned"
          v-model="enabled"
          @change="emitChanges()">
        </el-switch>
      </el-tooltip>
    </div>
    <div class="quantity-slider" v-if="option.allowMulEdit">
      <el-slider
        :min="option.minMul"
        :max="option.maxMul"
        v-if="!isSingular"
        class="option-slider"
        v-model="mul"
        @input="enabled = true; emitChanges()">
      </el-slider>
      <el-input-number
        v-model="mul"
        @change="enabled = true; emitChanges()"
        :min="option.minMul"
        :max="option.maxMul"
        v-if="!isSingular"
        :controls="false"
        size="small"
        class="quantity-input">
      </el-input-number>
    </div>
  </li>
</template>
<script>
import { Slider, Switch, InputNumber } from 'element-ui'
import { productOption } from './mixins/productOption.js'
import ServiceInfo from './ServiceInfo'

export default {
  name: 'subscription-option',
  mixins: [productOption],
  components: {
    'el-switch': Switch,
    'el-slider': Slider,
    'el-input-number': InputNumber,
    ServiceInfo
  },
  props: {
    timefrom: null,
    option: {
      type: Object,
      required: true
    },
    currency: ''
  },
  data() {
    return {
      mul: this.option.defaultMul,
      enabled: this.option.switchedOn
    }
  },
  computed: {
    isSingular: function() {
      return this.option.minMul === this.option.maxMul
    },
    optionPrice: function() {
      const { period, bulkService } = this.option
      let periodString = ''
      const unitString = bulkService ? `${this.$t('for')} ${this.$t('unit')}` : ''
      if (period === 0) {
        periodString = this.$t('once')
      } else if (bulkService) {
        periodString = ''
      } else {
        periodString = `${this.$t('for')} ${this.$t('Period').toLowerCase()}`
      }

      return `${this.priceWithDiscounts(this.option, this.timefrom)} ${this.currency} ${periodString} ${unitString}`
    },
    optionConnectPrice: function() {
      return `${this.priceWithDiscounts(this.option, this.timefrom, true)} ${this.currency} за подключение`
    }

  },
  watch: {
    option: function(val) {
      this.mul = val.defaultMul
      this.enabled = val.switchedOn
    }
  },
  methods: {
    emitChanges() {
      this.$emit('updateProductBuild', {
        servCatIdx: this.option.servCatIdx,
        mul: this.mul,
        switchedOn: this.enabled
      })
    }
  }
}
</script>
<style scoped>
.option:not(:last-child) {
  margin-bottom: 40px;
}
.option-name {
  font-size: 16px;
}
.option-toggle {
  margin-left: auto;
  flex: 0 0 auto;
}
.option-header {
  display: flex;
  align-items: flex-start;
}

.quantity-slider {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.option-slider {
  flex: 1 1 auto;
  margin-right: 20px;
}
.quantity-input {
  width: 60px;
  height: 32px;
}
.option-price {
  font-size: 13px;
  color: #909399;
  flex-shrink: 0;
}
.option-meta {
  display: flex;
  flex-direction: column;
}
</style>
